module.exports = __webpack_public_path__ + "img/logo.9b3ff5e5.png";